import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'budget';

const budgetService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getRowByProjectId: (projectId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/budgetByProjectId/${encodeURIComponent(projectId)}`,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};
export default budgetService;
